import PropTypes from 'prop-types';
import React from 'react';
import MaterialIcon from '@material-ui/core/Icon';
import useStyles from './Icon.styles';

export const sizeEnum = {
  default: 'default',
  small: 'small',
  large: 'large',
  inherit: 'inherit',
};

const Icon = ({ icon, className, classes: materialClasses, size, style, disabled }) => {
  const classes = useStyles();

  return (
    <MaterialIcon className={`${className} ${disabled ? classes.disabled : undefined}`} classes={materialClasses} style={style} fontSize={size}>
      {icon}
    </MaterialIcon>
  );
};

Icon.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
  classes: PropTypes.shape(),
  disabled: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.values(sizeEnum)),
  style: PropTypes.shape(),
};

Icon.defaultProps = {
  className: undefined,
  classes: undefined,
  disabled: false,
  size: sizeEnum.default,
  style: undefined,
};

export default Icon;
